<template>
  <el-select
    v-if="!props.config.tree"
    v-bind="$attrs"
    :placeholder="$t('common.pleaseSelect')"
    clearable
    filterable
  >
    <el-option
      v-for="(item, index) in props.config.options"
      :key="index"
      :disabled="item.disabled"
      :value="
        props.config?.objectValue
          ? item
          : (item.value ?? item.dictValue ?? item[props.config?.keyMap?.value])
      "
      :label="
        t(
          (item.label ?? item.dictLabel ?? item[props.config?.keyMap?.label]) ||
            ''
        )
      "
    />
  </el-select>
  <el-tree-select v-else v-bind="$attrs" :data="props.config.options" />
</template>
<script lang="ts">
import { defineComponent, ref } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "form-select",
  props: {
    config: {
      type: Object,
      required: true
    },
    FormRef: { type: Object, default: null }
  },
  setup(props) {
    const { t } = useI18n();
    return {
      t,
      props
    };
  }
});
</script>
